import React from 'react'

import { Grid, Row, Button } from 'react-bootstrap'
import SearchResults from '../LicenseOverview/search-results'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { find } from 'lodash'
import PropertyTitle from '../../components/PropertyTitle'
import Property from '../../components/Property'
import * as Orders from '../../services/Orders'
import { saveAs } from 'file-saver'

import { fetchLicensesByItemId, fetchOrder } from '../../actions/order-actions'

const OrderItem = (props) => (
  <div>
    <Property
      icon="file-text-o"
      value={<Link to={`/orders/${props.order.navisionId}`}>{props.order.navisionId}</Link>}
      tooltipText="Order"
    />
    <Property
      value={<Link to={`/producten/${props.item.productId}`}>{`${props.item.ean} - ${props.item.product}`}</Link>}
      icon="cube"
      tooltipText="Product"
    />
    <Property value={`${props.item.email ? props.item.email : ''} `} icon="envelope-o" />
    <Property value={props.item.webshopOrderItemId} icon="file-text-o" tooltipText="Webshop-order-item-id" />
    <Property value={props.item.quantity} icon="hashtag" tooltipText="Aantal" />
  </div>
)

class OrderItemLicenses extends React.Component {
  componentDidMount(props) {
    this.props.fetchOrder(this.props.match.params.id)
    this.props.fetchLicensesByItemId(this.props.match.params.navId)
  }

  exportLicenses(item) {
    Orders.exportLicenses(item.navisionId).then((result) => {
      let blob = new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      saveAs(blob, 'licenties.xlsx')
    })
  }

  render() {
    const orderItem = find(this.props.order.items, (i) => i.navisionId === this.props.match.params.navId)
    if (!orderItem) {
      return null
    }

    return (
      <Grid>
        <Row>
          <div className="content" style={{ minHeight: 0 }}>
            <div>
              <span className="title">
                <b>Orderregel {this.props.match.params.navId}</b>
              </span>
            </div>
            <OrderItem item={orderItem} order={this.props.order} />
            <PropertyTitle small text="Licenties" />
            <div className="tablescontainer">
              <SearchResults searchResults={this.props.licenses} history={this.props.history} full={false} />
              <Button bsStyle="success" onClick={() => this.exportLicenses(orderItem)}>
                Exporteer licenties
              </Button>
            </div>
          </div>
        </Row>
      </Grid>
    )
  }
}

export default connect(
  (state) => {
    return { licenses: state.orders.licenses, order: state.orders.detail }
  },
  { fetchLicensesByItemId, fetchOrder }
)(OrderItemLicenses)
